// @flow

import React from 'react';
import {components} from 'react-select2';
import SelectAndt, {
  DIRECTION_CENTER,
  THEME_TRANSPARENT,
  TYPE_SIMPLE,
} from 'common/componentsV2/ddl/selectAndt/SelectAndt';
import OptionWithIcon from 'common/componentsV2/ddl/selectAndt/innerComponents/OptionWithIcon';
import './AlertManagerFooterPause.module.scss';
import connect from 'react-redux/es/connect/connect';

type PropTypes = {
  onApply: Function,
};

@connect(
  () => ({}),
  {},
)
export default class AlertManagerFooterMore extends React.PureComponent {
  props: PropTypes;

  handlePauseChange = (val) => {
    this.props.onApply(val);
  };

  // TODO GABPAC - clear all tags
  render() {
    return (
      <SelectAndt
        type={TYPE_SIMPLE}
        theme={THEME_TRANSPARENT}
        onChange={this.handlePauseChange}
        options={[
          {value: 'resume', label: 'Resume Alerts', icon: 'icn-action16-resume'},
          {value: 'assignOwner', label: 'Assign Owner', icon: 'icn-general16-group'},
        ]}
        direction={DIRECTION_CENTER}
        menuWidth={200}
        automationId="footer-more"
        menuPlacement="top"
        customComponent={{
          Option: OptionWithIcon,
          DropdownIndicator: (p) => (
            <div {...p.innerProps} styleName="footer-button-like">
              <i className="icn-general16-3dot" />
              <span>More</span>
            </div>
          ),
          IndicatorsContainer: (p) => (
            <div style={{height: '38px', display: 'flex'}}>
              <components.IndicatorsContainer {...p}>{p.children}</components.IndicatorsContainer>
            </div>
          ),
        }}
      />
    );
  }
}
